import { PriceListRerunStatus } from '../../services/PriceListRerunService';

// Execução de reprocessamento iniciada neste navegador. Fica no localStorage, compartilhado entre as abas: o aviso
// de fim sai em qualquer aba do usuário que disparou, também depois de recarregar, até ele fechar (IT-5154).

export const PRICE_LIST_RERUN_STORAGE_KEY = 'ipa:price-list-rerun:pending';

export const PRICE_LIST_RERUN_STARTED_EVENT = 'ipa:price-list-rerun:started';

export type PriceListRerunFinishedResult = {
  status?: PriceListRerunStatus;
  written?: number;
};

export type PendingPriceListRerun = {
  executionId: string;
  startedAt: string;
  /** E-mail de quem disparou; outro usuário no mesmo navegador não recebe o aviso. */
  user: string | null;
  finished?: PriceListRerunFinishedResult;
  dismissed?: boolean;
};

export const getCurrentUserEmail = (): string | null => {
  try {
    return JSON.parse(window.localStorage.getItem('usuario') ?? 'null')?.email ?? null;
  } catch {
    return null;
  }
};

export const getPendingPriceListRerun = (): PendingPriceListRerun | null => {
  try {
    const raw = window.localStorage.getItem(PRICE_LIST_RERUN_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed?.executionId ? parsed : null;
  } catch {
    return null;
  }
};

const savePending = (pending: PendingPriceListRerun) => {
  window.localStorage.setItem(PRICE_LIST_RERUN_STORAGE_KEY, JSON.stringify(pending));
};

export const setPendingPriceListRerun = (executionId: string) => {
  savePending({ executionId, startedAt: new Date().toISOString(), user: getCurrentUserEmail() });
  window.dispatchEvent(new CustomEvent(PRICE_LIST_RERUN_STARTED_EVENT));
};

/** Grava o resultado só se a pendência ainda for a mesma execução. */
export const markPriceListRerunFinished = (executionId: string, finished: PriceListRerunFinishedResult) => {
  const pending = getPendingPriceListRerun();
  if (pending?.executionId !== executionId || pending.finished) return;
  savePending({ ...pending, finished });
};

export const dismissPriceListRerun = (executionId: string) => {
  const pending = getPendingPriceListRerun();
  if (pending?.executionId !== executionId || pending.dismissed) return;
  savePending({ ...pending, dismissed: true });
};

export const clearPendingPriceListRerun = () => {
  window.localStorage.removeItem(PRICE_LIST_RERUN_STORAGE_KEY);
};

/** Vale só no dia em que foi disparada (uma execução por dia) e para o usuário que disparou. */
export const isPendingForCurrentUserToday = (pending: PendingPriceListRerun) => {
  const started = new Date(pending.startedAt);
  const sameDay = !Number.isNaN(started.getTime()) && started.toDateString() === new Date().toDateString();
  const currentUser = getCurrentUserEmail();
  const sameUser = !pending.user || !currentUser || pending.user === currentUser;
  return sameDay && sameUser;
};
